import styled from 'styled-components';

export default styled.div`
  .errors {
    margin-top: 4px;
    color: #d31e1e;
  }

  .errors .errors-element {
    font-size: 12px;
    line-height: 1.33;
    -webkit-letter-spacing: 0.5px;
    -moz-letter-spacing: 0.5px;
    -ms-letter-spacing: 0.5px;
    letter-spacing: 0.5px;
    color: #ff4747;
  }
`;
